mutation CommunicationGroupCreate($input: CommunicationGroupCreateInput!) {
  communicationGroupCreate(input: $input) {
    communicationGroup {
      id
      _rowTimestamp
      name
      description
      _isUpdatable
      _isDeletable
      communicationGroupItemsByCommunicationGroupId(
        orderBy: COMMUNICATION_CHANNEL_BY_COMMUNICATION_CHANNEL_ID__NAME_ASC
      ) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          endCursor
        }
        totalCount
        nodes {
          id
          _rowTimestamp
          communicationChannelId
          _communicationChannelName
          isSenderOnly
          isRecipientOnly
          _isUpdatable
          _isDeletable
          communicationChannel {
            _isAlerts
          }
        }
      }
    }
  }
}
